import { User } from 'firebase/auth';

export const initiateGoogleCalendarConnection = async (user: User): Promise<void> => {
  if (!user) {
    throw new Error('You must be signed in to connect Google Calendar.');
  }

  try {
    const token = await user.getIdToken();
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/google-calendar/url?token=${encodeURIComponent(token)}`);

    if (!response.ok) {
      throw new Error('Failed to get authorization URL');
    }

    const { authUrl } = await response.json();
    window.location.href = authUrl;
  } catch (error) {
    console.error('Error initiating Google Calendar OAuth:', error);
    throw new Error('Failed to connect to Google Calendar. Please try again.');
  }
};

export const disconnectGoogleCalendar = async (user: User): Promise<void> => {
  const token = await user.getIdToken();
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/google-calendar/disconnect`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error('Failed to disconnect Google Calendar');
  }
};
